import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=22fd4589&"
import script from "./MetadataForm.vue?vue&type=script&lang=js&"
export * from "./MetadataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fd4589')) {
      api.createRecord('22fd4589', component.options)
    } else {
      api.reload('22fd4589', component.options)
    }
    module.hot.accept("./MetadataForm.vue?vue&type=template&id=22fd4589&", function () {
      api.rerender('22fd4589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/rules/components/MetadataForm.vue"
export default component.exports